import React from 'react';
import { useSelector } from 'react-redux';
import DashboardContainer from '../customDashboards/dashboardContainer';
import { PRECONFIGURED_TYPES } from '../customDashboards/widgetDataTypes';
import { getIsAgency } from '../selectors/user';

export default function Page() {
    const isAgency = useSelector(getIsAgency);
    return (
        <DashboardContainer
            preconfiguredType={PRECONFIGURED_TYPES.CREATIVE}
            includeImpersonated={isAgency}
            readOnly={isAgency}
        />
    );
}
